<template>
  <Layout v-loading="isLoading">
    <template #top>
      <Head :searchConfig="tableData.searchConfig" @addBusiness="addBusiness" />
    </template>
    <template>
      <Body
        :headConfig="tableData.headConfig"
        :tableData="data"
        @deleteBusiness="deleteBusiness"
      />
    </template>
    <template>
      <RealizationMember ref="popups" @getData="getData" />
    </template>
  </Layout>
</template>

<script>
import getPlayerAppIdBind from "@/api/getPlayerAppIdBind.js";
import Layout from "@/components/Layout";
import Head from "@/components/Table/Head";
import Body from "@/components/Table/Body";
import Foot from "@/components/Table/Foot";
import requstData from "@/mixins/requstData.js";
import RealizationMember from "@/components/RealizationMember";

export default {
  mixins: [requstData([], true)],
  components: {
    Layout,
    Head,
    Body,
    Foot,
    RealizationMember,
  },
  data() {
    return {
      tableData: {
        headConfig: {
          select: false,
          key: "pageId",
          list: [
            { label: "用户", prop: "userName" },
            { label: "应用ID", prop: "appName" },
            {
              label: "操作",
              operation: [
                {
                  type: 1,
                  label: "删除绑定",
                  style: "danger",
                  listeners: "deleteBusiness",
                },
              ],
            },
          ],
        },
        searchConfig: {
          list: [
            {
              type: "button",
              span: 5,
              operation: [
                {
                  type: 1,
                  label: "+新增用户绑定",
                  style: "success",
                  listeners: "addBusiness",
                },
              ],
            },
          ],
        },
      },
    };
  },
  methods: {
    async requst(params) {
      return await getPlayerAppIdBind();
    },
    addBusiness(data) {
      this.$refs.popups.show(0);
    },
    deleteBusiness(data) {
      this.$refs.popups.show(1, data.userName);
    },
  },
};
</script>
<style lang="less"></style>
